import React from "react";

export const defaultscopeparameters = [
  {
    label:
      "Total Scope 1 emissions (Break-up of the GHG into CO2, CH4, N2O, HFCs, PFCs, SF6, NF3, if available)",
    unit: "Metric tonnes of CO2 equivalent",
    current: "",
    previous: "",
  },
  {
    label:
      "Total Scope 2 emissions (Break-up of the GHG into CO2, CH4, N2O, HFCs, PFCs, SF6, NF3, if available)",
    unit: "Metric tonnes of CO2 equivalent",
    current: "",
    previous: "",
  },
  {
    label:
      "Total Scope 1 and Scope 2 emission intensity per rupee of turnover (Total Scope 1 and Scope 2 GHG emissions/ Revenue from operations)",
    unit: "",
    current: "",
    previous: "",
  },
  {
    label:
      "Total Scope 1 and Scope 2 emission intensity per rupee of turnover adjusted for Purchasing Power Parity (PPP) (Total Scope 1 and Scope 2 GHG emissions / Revenue from operations adjusted for PPP)",
    unit: "",
    current: "",
    previous: "",
  },
  {
    label:
      "Total Scope 1 and Scope 2 emission intensity in terms of physical output",
    unit: "",
    current: "",
    previous: "",
  },
  {
    label:
      "Total Scope 1 and Scope 2 emission intensity (optional) – the relevant metric may be selected by the entity",
    unit: "",
    current: "",
    previous: "",
  },
];

const Scope1And2GHGEmissionTable = ({ scopeData = [], setScopeData }) => {
  const flatData = scopeData.length > 0 ? scopeData : defaultscopeparameters;

  const handleChange = (index, field, value) => {
    const updated = [...flatData];
    updated[index][field] = value;
    setScopeData(updated);
  };

  return (
    <div
      style={{
        marginTop: 20,
        overflowX: "auto",
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#d3c9ce", fontWeight: "bold" }}>
            <th style={{ ...headerStyle, width: "40%" }}>Parameter</th>
            <th style={headerStyle}>Unit</th>
            <th style={headerStyle}>
              FY _____ <br />
              Current Financial Year
            </th>
            <th style={headerStyle}>
              FY _____ <br />
              Previous Financial Year
            </th>
          </tr>
        </thead>
        <tbody>
          {flatData.map((row, index) => (
            <tr key={index}>
              <td style={labelCellStyle}>{row.label}</td>
              <td style={unitCellStyle}>{row.unit}</td>
              <td style={inputCellStyle}>
                <input
                  type="text"
                  placeholder="Current FY"
                  value={row.current || ""}
                  onChange={(e) =>
                    handleChange(index, "current", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={inputCellStyle}>
                <input
                  type="text"
                  placeholder="Previous FY"
                  value={row.previous || ""}
                  onChange={(e) =>
                    handleChange(index, "previous", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const headerStyle = {
  padding: "15px",
  border: "1px solid #000",
  textAlign: "center",
  backgroundColor: "#d3c9ce",
};

const labelCellStyle = {
  padding: "15px",
  border: "1px solid #000",
  backgroundColor: "#d3c9ce",
  textAlign: "left",
  verticalAlign: "top",
  whiteSpace: "normal",
  lineHeight: "1.5",
};

const unitCellStyle = {
  padding: "14px",
  border: "1px solid #000",
  textAlign: "left",
  backgroundColor: "#fff",
};

const inputCellStyle = {
  padding: "14px",
  border: "1px solid #000",
  textAlign: "center",
  backgroundColor: "#fff",
};

const inputStyle = {
  width: "80%",
  padding: "8px",
  fontSize: "14px",
  border: "1px solid grey",
  borderRadius: "6px",
  outline: "none",
  textAlign: "center",
};

export default Scope1And2GHGEmissionTable;
